module.exports = __webpack_public_path__ + "static/A1xF2_03Q_P560-S1-P906.5236370a.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/A1xF2_03Q_P560-S1-P906.jpg
// module id = 848
// module chunks = 168707334958949